import * as actions from "../actions/account";
import { LocalStorageKeys } from "../types/enums";

const initialState = {
  initialTourCompletedDateTimeUtc: null,
  eventsGridTourCompletedDateTimeUtc: null,
  monitoringGridTourCompletedDateTimeUtc: null,
  incidentsGridTourCompletedDateTimeUtc: null,
  isLoading: true,
  organizationUsers: [],
  language: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.ACCOUNT_LOAD:
      return {
        ...state,
        isLoading: true,
        hasErrored: false,
      };
    case actions.ACCOUNT_LOAD_SUCCESS:
      // Merge database roles with Auth0 roles
      if (action.payload.data.userRoles) {
        // Get existing Auth0 roles from localStorage (if any)
        const existingRoles = localStorage.getItem(LocalStorageKeys.UserRoles);
        const auth0Roles = existingRoles
          ? existingRoles
              .split(",")
              .map((r) => r.trim())
              .filter((r) => r)
          : [];

        // Get database roles from API response
        const dbRoles = action.payload.data.userRoles
          .map((r) => r.trim())
          .filter((r) => r);

        // Merge and deduplicate
        const allRoles = [...new Set([...auth0Roles, ...dbRoles])];

        // Store merged roles back in localStorage
        localStorage.setItem(LocalStorageKeys.UserRoles, allRoles.join(","));
      }

      return {
        ...state,
        ...action.payload.data,
        isLoading: false,
        hasErrored: false,
      };
    case actions.ACCOUNT_LOAD_FAIL:
      return {
        ...state,
        isLoading: false,
        hasErrored: true,
        errorMessage: action.error.message,
      };

    case actions.ACCOUNT_UPDATE_SUCCESS:
      return {
        ...state,
        ...action.meta.previousAction,
      };
    default:
      break;
  }
  return state;
};
